export const tokens = {
    drawer: {
        offsetY: 20,
        maxHeight: 320,
        radius: 32,
    },
    section: {
        padding: 20,
    },
};
